module.exports = __webpack_public_path__ + "static/media/icon_user.6f6bb874.svg";